import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["boxSize", "color"];
import React from 'react';
import { BaseIcon } from "../../../index.js";
export var SearchIcon = function SearchIcon(_ref) {
  var boxSize = _ref.boxSize,
    color = _ref.color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    viewBox: "0 0 24 24",
    boxSize: boxSize,
    color: color
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 17C13.3137 17 16 14.3137 16 11C16 7.68629 13.3137 5 10 5C6.68629 5 4 7.68629 4 11C4 14.3137 6.68629 17 10 17Z",
    fill: "#FFFFFF",
    stroke: "#413F37",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 19L14.8057 14.8128",
    stroke: "#413F37",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};